import { DemoTag } from "@components/common/demo-tag";
import { FaroCardImage } from "@components/common/faro-card/faro-card-image";
import { BaseGroupProps } from "@custom-types/group-types";
import { isGroupDemo } from "@utils/group-utils";
import defaultThumbnail from "/src/assets/group-thumbnail_default.svg";

/**
 * Top section of a group card that show the group thumbnail image.
 */
export function GroupCardTop({ group }: BaseGroupProps): JSX.Element {
  return (
    <>
      <FaroCardImage
        src={group.thumbnailUrl ? group.thumbnailUrl : defaultThumbnail}
        alt={group.name}
        // Don't translate the group name in the alt attribute
        shouldNotTranslate
        contextType="group"
        contextId={group.id}
      />
      {/* If the group is a demo group shows a demo tag on the top left side */}
      {isGroupDemo(group) && (
        <DemoTag
          sx={{
            position: "absolute",
            top: "15px",
            left: "15px",
          }}
        />
      )}
    </>
  );
}
